import { isoDateToString } from "../../util/format-date";

export default function PaymentDetail({ payment }) {
  const classNames = () => {
    let classes = "pill grid lg:grid-cols-7 ";
    if (payment.status === "succeeded") classes += "border-green-600";
    if (payment.status === "approved") classes += "border-blue-600";
    if (payment.status === "declined") classes += "border-red-600";
    if (payment.status === "pending") classes += "border-yellow-600";
    return classes;
  };
  return (
    <div className={classNames()}>
      <p className="font-semibold text-stone-200">
        {isoDateToString(payment.datePaid || payment.dateCreated)}
      </p>
      <p className="lg:col-span-3">{payment.description}</p>
      <p className="text-stone-400">{payment.association}</p>
      <div data-tour="payment-receipt">
        {payment.receipt ? (
          <a
            href={payment.receipt || "-"}
            target="_blank"
            className="text-yellow-600 underline"
          >
            Receipt
          </a>
        ) : (
          <p className="text-stone-400">No Receipt</p>
        )}
      </div>
      <p className="font-semibold text-right text-white">
        ${Number(payment.amount).toFixed(2)}
      </p>
    </div>
  );
}
